import { Suspense, lazy } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Layout, PageLoader } from '~/components';
import { ChartProvider, UserContextProvider } from '~/providers';

const LandingRoute = lazy(() => import('./LandingRoute'));
const MockRoute = lazy(() => import('./MockRoute'));
const TargetIncomeRoute = lazy(() => import('./TargetIncomeRoute'));
const StatePensionRoute = lazy(() => import('./StatePensionRoute'));
const FinalSalaryRoute = lazy(() => import('./FinalSalaryRoute'));
const OtherIncomeRoute = lazy(() => import('./OtherIncomeRoute'));
const OtherPensionPotsRoute = lazy(() => import('./OtherPensionPotsRoute'));
const AvailablePotRoute = lazy(() => import('./AvailablePotRoute'));
const AnnuityRoute = lazy(() => import('./AnnuityRoute'));
const DrawdownRoute = lazy(() => import('./DrawdownRoute'));
const WhatsNextRoute = lazy(() => import('./WhatsNextRoute'));
const ExploreRoute = lazy(() => import('./ExploreRoute'));
const NextStepsRoute = lazy(() => import('./NextStepsRoute.tsx'));

export const AppRoutes = () => {
    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                {import.meta.env.VITE_ENABLE_MOCK_ROUTE === 'true' && (
                    <Route path="/mock/:mockScenario?" element={<MockRoute />} />
                )}
                <Route
                    element={
                        <Layout>
                            <UserContextProvider>
                                <ChartProvider>
                                    <Outlet />
                                </ChartProvider>
                            </UserContextProvider>
                        </Layout>
                    }
                >
                    <Route path="/" element={<LandingRoute />} />
                    <Route path="/target-income" element={<TargetIncomeRoute />} />
                    <Route path="/state-pension" element={<StatePensionRoute />} />
                    <Route path="/final-salary" element={<FinalSalaryRoute />} />
                    <Route path="/other-income" element={<OtherIncomeRoute />} />
                    <Route path="/other-pensions" element={<OtherPensionPotsRoute />} />
                    <Route path="/available-pot" element={<AvailablePotRoute />} />
                    <Route path="/annuity" element={<AnnuityRoute />} />
                    <Route path="/drawdown" element={<DrawdownRoute />} />
                    <Route path="/whats-next" element={<WhatsNextRoute />} />
                    <Route path="/explore" element={<ExploreRoute />} />
                    <Route path="/next-steps" element={<NextStepsRoute />} />
                </Route>
            </Routes>
        </Suspense>
    );
};
